import { z } from "zod";

export const userAddressSchema = z.object({
    name: z.string().min(2, "Name must be at least 2 characters"),
    street: z.string().min(5, "Street address must be at least 5 characters"),
    suite: z.string().optional(),
    city: z.string().min(2, "City must be at least 2 characters"),
    state: z.string().min(2, "State must be at least 2 characters"),
    postal_code: z.string().min(5, "ZIP code must be at least 5 characters"),
    country: z.string().min(2, "Country must be at least 2 characters"),
  })